// Executive Dashboard mock data

export const tenantScoreboard = [
  {
    rank: 1,
    initials: "BJ",
    name: "BMW JIS Center",
    type: "JIS · Layer 4",
    loopCompletion: 100,
    s1s2: { closed: 1, total: 1 },
    eightD: { closed: 1, total: 1 },
    fmea: { approved: 1, total: 1 },
    avgDays: "3.2d",
    pipeline: ["green", "green", "green", "green"],
  },
  {
    rank: 2,
    initials: "HR",
    name: "Hörmann Logistics",
    type: "3PL · Layer 4",
    loopCompletion: 88,
    s1s2: { closed: 2, total: 2 },
    eightD: { closed: 2, total: 2 },
    fmea: { approved: 1, total: 2 },
    avgDays: "5.1d",
    pipeline: ["green", "green", "amber", "amber"],
  },
  {
    rank: 3,
    initials: "DB",
    name: "DB Schenker",
    type: "Road Carrier · Layer 3",
    loopCompletion: 72,
    s1s2: { closed: 3, total: 3 },
    eightD: { closed: 2, total: 3 },
    fmea: { approved: 2, total: 3 },
    avgDays: "8.4d",
    pipeline: ["green", "amber", "amber", "amber"],
  },
  {
    rank: 4,
    initials: "LE",
    name: "Leoni AG",
    type: "TIER1 · Layer 1",
    loopCompletion: 58,
    s1s2: { closed: 4, total: 4 },
    eightD: { closed: 3, total: 4 },
    fmea: { approved: 1, total: 4 },
    avgDays: "14.2d",
    pipeline: ["green", "amber", "amber", "grey"],
  },
  {
    rank: 5,
    initials: "IN",
    name: "Inteva Products",
    type: "TIER1 · Layer 1",
    loopCompletion: 33,
    s1s2: { closed: 3, total: 3 },
    eightD: { closed: 1, total: 3 },
    fmea: { approved: 0, total: 3 },
    avgDays: "21.6d",
    pipeline: ["green", "amber", "grey", "grey"],
  },
  {
    rank: 6,
    initials: "RH",
    name: "Rehau AG",
    type: "TIER2 · Layer 1",
    loopCompletion: 0,
    s1s2: { closed: 2, total: 2 },
    eightD: { closed: 0, total: 2 },
    fmea: { approved: 0, total: 2 },
    avgDays: "—",
    pipeline: ["green", "grey", "grey", "grey"],
  },
];

export const openLoops = [
  {
    tenant: "Rehau AG",
    incident: "INC-2024-0879",
    opened: "15 days ago",
    stage: "No 8D started",
    daysStalled: 15,
    risk: "high",
    action: "Send reminder",
  },
  {
    tenant: "Inteva Products",
    incident: "INC-2024-0891",
    opened: "12 days ago",
    stage: "8D open, no FMEA",
    daysStalled: 8,
    risk: "high",
    action: "Send reminder",
  },
  {
    tenant: "Inteva Products",
    incident: "INC-2024-0888",
    opened: "10 days ago",
    stage: "No 8D started",
    daysStalled: 10,
    risk: "high",
    action: "Send reminder",
  },
  {
    tenant: "Leoni AG",
    incident: "INC-2024-0875",
    opened: "6 days ago",
    stage: "FMEA pending approval",
    daysStalled: 3,
    risk: "medium",
    action: "Approve FMEA →",
  },
];

// 12-week trend per tenant (loop completion %)
export const loopTrend = (() => {
  const weeks = Array.from({ length: 12 }, (_, i) => `W${i + 1}`);
  const tenants = [
    { name: "BMW JIS Center", color: "#27ae60", base: 80, slope: 1.8 },
    { name: "Hörmann", color: "#5fa3e3", base: 70, slope: 1.5 },
    { name: "DB Schenker", color: "#f3b14a", base: 55, slope: 1.4 },
    { name: "Leoni AG", color: "#c89adb", base: 40, slope: 1.5 },
    { name: "Inteva", color: "#E24B4A", base: 25, slope: 0.6 },
    { name: "Rehau AG", color: "#ff8a4c", base: 10, slope: 0.3 },
  ];
  return weeks.map((w, i) => {
    const row = { week: w };
    tenants.forEach((t) => {
      const wobble = (Math.sin(i * 0.9 + t.base) * 4 + (i + 1) * t.slope);
      row[t.name] = Math.max(0, Math.min(100, Math.round(t.base + wobble)));
    });
    return row;
  });
})();

export const loopTrendTenants = [
  { name: "BMW JIS Center", color: "#27ae60" },
  { name: "Hörmann", color: "#5fa3e3" },
  { name: "DB Schenker", color: "#f3b14a" },
  { name: "Leoni AG", color: "#c89adb" },
  { name: "Inteva", color: "#E24B4A" },
  { name: "Rehau AG", color: "#ff8a4c" },
];

// Tenant detail incidents — keyed by tenant name
export const tenantIncidentPipeline = {
  "BMW JIS Center": [
    {
      id: "INC-2024-0884",
      title: "Inbound premium freight — Air charter",
      severity: "S1",
      stages: ["done", "done", "done", "done"],
      stalledAt: null,
      stallDays: 0,
    },
  ],
  "Hörmann Logistics": [
    {
      id: "INC-2024-0852",
      title: "Receiving dock congestion",
      severity: "S2",
      stages: ["done", "done", "done", "done"],
      stalledAt: null,
      stallDays: 0,
    },
    {
      id: "INC-2024-0847",
      title: "Pallet labeling mismatch",
      severity: "S2",
      stages: ["done", "done", "in-progress", "pending"],
      stalledAt: "FMEA",
      stallDays: 2,
    },
  ],
  "DB Schenker": [
    {
      id: "INC-2024-0875",
      title: "Inbound transport delay — Budapest",
      severity: "S2",
      stages: ["done", "done", "done", "in-progress"],
      stalledAt: "Jira ticket",
      stallDays: 3,
    },
    {
      id: "INC-2024-0862",
      title: "Border customs hold — DE/CZ",
      severity: "S2",
      stages: ["done", "done", "in-progress", "pending"],
      stalledAt: "FMEA",
      stallDays: 4,
    },
    {
      id: "INC-2024-0853",
      title: "Cross-dock backlog",
      severity: "S2",
      stages: ["done", "done", "done", "done"],
      stalledAt: null,
      stallDays: 0,
    },
  ],
  "Leoni AG": [
    {
      id: "INC-2024-0888",
      title: "Line Stoppage — Wiring harness shortage",
      severity: "S1",
      stages: ["done", "done", "in-progress", "pending"],
      stalledAt: "FMEA",
      stallDays: 3,
    },
    {
      id: "INC-2024-0855",
      title: "Wiring harness buffer depletion",
      severity: "S1",
      stages: ["done", "done", "done", "in-progress"],
      stalledAt: "Jira ticket",
      stallDays: 2,
    },
  ],
  "Inteva Products": [
    {
      id: "INC-2024-0891",
      title: "JIS Sequence Error — Line 7 Body Shop",
      severity: "S1",
      stages: ["done", "in-progress", "pending", "pending"],
      stalledAt: "8D",
      stallDays: 8,
    },
    {
      id: "INC-2024-0879",
      title: "Quality Lock — Seat trim defect",
      severity: "S2",
      stages: ["done", "in-progress", "pending", "pending"],
      stalledAt: "8D",
      stallDays: 6,
    },
  ],
  "Rehau AG": [
    {
      id: "INC-2024-0879",
      title: "Sub-panel fitment drift",
      severity: "S2",
      stages: ["done", "pending", "pending", "pending"],
      stalledAt: "8D",
      stallDays: 15,
    },
  ],
};
